/**
 * documentRepositoryRecordCell.js — historia 170 (Repositorio Documental), J1. Pure decision (no JSX,
 * no i18n) for the "Associated record" column of one R2 row (`DocumentRepositoryEntryDto`).
 *
 * G2-4/G2-9 point 5: `recordTaskCount` (only present on FEATURE_TASK/FEATURE_GROUP) drives three
 * cases:
 *   - `0`  — no vigent task at all (anomaly): show ONLY the record's own label, never a path or a
 *            task count, even if Sun still sent one (defensive: RN6b says this must never carry
 *            navigation either, so a stray path here would be a dead end anyway).
 *   - `>1` — several vigent tasks (anomaly, RN6b/G1-9): the record itself is ambiguous, so show the
 *            count instead of guessing which one.
 *   - `1` or `null` (normal FEATURE_* / any other topic) — behaves like every other row: label plus
 *            its ancestor path (RN6) if `recordPath` is not empty.
 */
export const describeAssociatedRecord = (row) => {
  const recordTaskCount = row.recordTaskCount

  if (recordTaskCount === 0) {
    return { kind: 'label', code: row.recordCode, name: row.recordName, path: [] }
  }
  if (typeof recordTaskCount === 'number' && recordTaskCount > 1) {
    return { kind: 'taskCount', count: recordTaskCount }
  }
  return { kind: 'label', code: row.recordCode, name: row.recordName, path: row.recordPath || [] }
}

// Developer request (post-J5): " — " only separates two parts that both exist. `null`/`undefined`
// come straight from R2 (external data), hence the explicit comparison.
const hasText = (value) => value !== null && value !== undefined && String(value) !== ''

export const joinRecordLabel = (first, second) =>
  [first, second].filter(hasText).join(' — ')

/** The row's own segment in `recordPath` (same topic and record), never one of its containers. */
export const isOwnPathSegment = (row, segment) =>
  segment.topic === row.topic && segment.referenceId === row.referenceId

/** "code — name", except WORKFLOW rows: "code — version", the version read from their own segment. */
export const associatedRecordLabel = (row) => {
  if (row.topic === 'WORKFLOW') {
    const ownSegment = (row.recordPath || []).find((segment) => isOwnPathSegment(row, segment))
    return joinRecordLabel(row.recordCode, ownSegment ? ownSegment.version : '')
  }
  return joinRecordLabel(row.recordCode, row.recordName)
}
